/* src/app/reports-view/visa-reports/visa-reports.component.css */
.spinner-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 150px;
  width: 75%;
}
/*# sourceMappingURL=visa-reports.component.css.map */
